import * as React from 'react';


export default class Copy extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/2000/svg">
       <g fill="none" fillRule="evenodd">
            <rect width="7.308" height="9.167" x="5.088" y="3.833" rx="1"/>
            <path d="M4.044 11.167c-.577 0-1.044-.41-1.044-.917V2.917C3 2.41 3.467 2 4.044 2h5.22c.576 0 1.044.41 1.044.917"/>
        </g>
      </svg>
    )
  }
}
